import React from "react";
import { Input } from "../../controls";
import { Box, IconButton, InputAdornment } from "@mui/material";
import Form from "../Form";

const DeepSearch = ({ setSearchVal, searchVal, handleSearch }) => {
  const handleSerach = (e) => {
    var _searchVal = e.target.value;
    setSearchVal(_searchVal);
  };

  return (
    <Box sx={{ width: { xs: "100%", md: "auto" } }}>
      <Form noValidate onSubmit={handleSearch}>
        <Input
          name="search"
          placeholder="Deep Search"
          size="small"
          onChange={handleSerach}
          value={searchVal}
          sx={{
            "& .MuiInputBase-root": {
              paddingRight: "2px",
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton type="submit" size="small" sx={{ p: "5px" }}>
                  🔍
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Form>
    </Box>
  );
};

export default DeepSearch;
